import styled from 'styled-components';

export const DeckImg = styled.img`
  border: 1px solid #bbbbbb;
  border-radius: 6px;
  width: 130px;
  height: 86px;
  cursor: pointer;
  @media only screen and (max-width: 1728px) {
    width: 96px;
    height: 62px;
  }
`;

export const DeckDetails = styled.div`
  display: flex;
  top: -36px;
  padding: 8px;
  position: relative;
  width: 130px;
  justify-content: space-between;
  gap: 8px;
  @media only screen and (max-width: 1728px) {
    width: 96px;
    top: -32px;
  }
`;

export const QueryResults = styled.span`
  background: #000000;
  opacity: 0.6;
  border-radius: 8px;
  color: #fff;
  font-size: 1.2rem;
  padding: 0 5px;
  @media only screen and (max-width: 1728px) {
    padding: 1px 4px;
  }
`;

export const DeckName = styled(QueryResults)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 50%;
`;

export const ErrorContainer = styled.img`
  top: 30%;
  left: 30%;
  position: absolute;
`;
